import React, { Component } from 'react';
import Slider from 'react-slick';
import Layer1 from '../../common/001_slider.jpg';
import imgHanko from '../../common/app2soft/images/hanko.jpg';
import imgThomas from '../../common/app2soft/images/thomas.jpg';

class DiscoverServices extends Component{
  constructor() {
    super();
  }
  render(){
    let settings = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
    };
    return(
      <Slider {...settings}>
        <div className="slide welcome">
          <div className="main">
            <h2>We Are App2Soft</h2>
            <p>A software consulting firm that provides top of the line software development services surpassing each of our client’s expectations</p>
          </div>
        </div>
        <div className="slide testimonial">
          <div className="main">
            <img src={imgHanko} width="105" />
            <div className="text">
            <p>
              The Costa Rica office is an essential business partner and we continue to look to them for reliable service. We greatly appreciate our association with App2Soft.
            </p>
              <span>Hanko Kiessner<br/>CEO, Packsize International</span>
          </div>
          </div>
        </div>
        <div className="slide testimonial">
          <div className="main">
            <img src={imgThomas} width="105"/>
            <div className="text">
              <p>Having managed development teams all over the world, I’ve finally found a team location that really works with our need for real-time collaboration during U.S. work hours and without the communication challenges<br />
              </p>
              <span>Thomas Casselberry<br/>
              Director, Software Development | C.R. England</span>
          </div>
          </div>
        </div>
      </Slider>
    )
  }
}

export default DiscoverServices;



// WEBPACK FOOTER //
// ./src/components/homepage/views/slider.js